module.exports = __webpack_public_path__ + "img/banner.d2733a4.png";